import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTpsTransformation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinejoin: "round",
	strokeMiterlimit: 2,
	clipRule: "evenodd",
	viewBox: "0 0 14 14",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.278 2.016c.329.886.495 1.837.555 2.78a20.3 20.3 0 0 1-3.257-1.054A12 12 0 0 0 0 0c1.345.822 2.774 1.544 4.278 2.016M1.842 5.24c.995.265 2 .501 3.016.667a16 16 0 0 1-.332 2.944c-.928.034-1.875.099-2.761.378.209-1.313.237-2.669.077-3.989m-.38 5.413c.846-.479 1.849-.66 2.817-.76a13 13 0 0 1-.899 2.411C2.145 12.559.862 13.08 0 14c.666-1.019 1.146-2.172 1.462-3.347m3.457 1.424q.335-1.123.569-2.274c1.094-.058 2.194-.072 3.282-.203.054.752.172 1.512.429 2.222-1.425.106-2.858.112-4.28.255m5.8-.424c-.403-.686-.657-1.467-.794-2.25.927-.216 1.878-.637 2.526-1.334.318.838.888 1.592 1.549 2.198-.858.82-2.108 1.199-3.281 1.386m1.491-4.461c-.631.651-1.519 1.066-2.399 1.283a14 14 0 0 1 .069-2.591 7 7 0 0 0 2.462-1.122c-.203.786-.272 1.631-.132 2.43m.436-3.362a9.1 9.1 0 0 1-2.632 1.066c.136-.864.319-1.721.524-2.572 1.177-.234 2.327-.597 3.462-.987-.534.78-1.01 1.612-1.354 2.493M9.259 2.523c-.094.852-.203 1.702-.296 2.554-.981.113-1.984.077-2.962-.064-.008-.883-.085-1.774-.29-2.632 1.162.225 2.371.269 3.548.142m-.397 3.544a26 26 0 0 0-.128 2.605c-1.014.129-2.041.137-3.063.153.154-.915.263-1.839.308-2.766.956.101 1.93.125 2.883.008"
	})
});
export default SvgIconTpsTransformation;
